export default "__VITE_ASSET__C90tQVG7__"